import * as React from 'react';

const SadFaceFilled48 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 48 48", width: 48, height: 48, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 24.004c0-11.05 8.95-20 20-20s20 8.95 20 20-8.95 20-20 20-20-8.95-20-20Zm1.5 0c0 10.2 8.3 18.5 18.5 18.5s18.5-8.3 18.5-18.5-8.3-18.5-18.5-18.5-18.5 8.3-18.5 18.5Zm18.565 1.6c1.73 0 3.49.37 5.16 1.17l.049.027c1.87.89 3.351 2.183 4.491 3.743l-1.24.85c-1.01-1.38-2.35-2.5-3.94-3.26a10.45 10.45 0 0 0-4.52-1.03c-3.42 0-6.61 1.55-8.56 4.29l-1.27-.85c2.28-3.26 5.98-4.94 9.83-4.94ZM17 20.754a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm15.25-1.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z",
    clipRule: "evenodd"
  }
));
SadFaceFilled48.Size = 48;
SadFaceFilled48.Title = "SadFaceFilled";

export { SadFaceFilled48 as default };
